// Ported from twifi-theme-html/src/scripts/helpers/document-type-toggle.js, mirroring this
// theme's own lib/account-type-toggle.js pattern.
//
// Drives the Verification tab's document-type radio-card selector inside
// parts/document-verification-modal.twig: the checked radio marks its own option active.
function initDocumentToggle(root) {
    const options = Array.from(root.querySelectorAll('.document-type__option'));
    const panels = root.querySelectorAll('[data-document-panel]');

    function sync() {
        options.forEach((option) => {
            const input = option.querySelector('.document-type__input');

            option.classList.toggle('document-type__option--active', input.checked);

            if (input.checked) {
                panels.forEach((panel) => {
                    panel.hidden = panel.dataset.documentPanel !== input.value;
                });
            }
        });
    }

    options.forEach((option) => {
        option.querySelector('.document-type__input').addEventListener('change', sync);
    });

    sync();
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-document-toggle]').forEach(initDocumentToggle);
});
